import { CustomerUiProvider } from "@babackapp/customer-ui/components/provider";
import { TooltipProvider } from "@babackapp/customer-ui/components/tooltip";
import {
  configureMerchantToken,
  configureReturnWidgetBaseUrl,
} from "@babackapp/private-api-client/client/return-widget-client";
import { tokenManager } from "@babackapp/auth-client/utils";
import { createStore, Provider } from "jotai";
import { AnimatePresence, motion } from "motion/react";
import { Suspense } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import { WidgetErrorBoundary } from "./widget-error-boundary";

// Configure the return widget API client to use the same API URL and merchant
// token as the rest of baback-office, so CORS and auth work correctly.
configureReturnWidgetBaseUrl(import.meta.env.VITE_API_URL ?? "https://api.baback.co/");
configureMerchantToken(() => tokenManager.getAccessToken());

const widgetStore = createStore();

export function ReturnWidgetLayout() {
  const segment = useLocation().pathname.split("/")[3];
  const outlet = useOutlet();

  return (
    <Provider store={widgetStore}>
      <TooltipProvider>
        <CustomerUiProvider className="h-screen w-screen bg-white flex flex-col overflow-hidden">
          <div className="relative flex-1 min-h-0 flex flex-col">
            <div className="flex-1 min-h-0 z-0 relative overflow-hidden flex flex-col p-8">
              <WidgetErrorBoundary>
                <Suspense>
                  <AnimatePresence mode="wait" propagate>
                    <motion.div key={segment} className="flex-1 min-h-0 w-full flex flex-col">
                      {outlet}
                    </motion.div>
                  </AnimatePresence>
                </Suspense>
              </WidgetErrorBoundary>
            </div>
          </div>
        </CustomerUiProvider>
      </TooltipProvider>
    </Provider>
  );
}
